export default __webpack_public_path__ + "static/media/Miscellaneous07.8e0e581f.jpg";